import React from 'react';

const Button = ({ onClick, image }) => {
    return (
        <button
            onClick={onClick}
            className={`flex items-center gap-2`}
        >
            {image && <img src={image} alt="" className="w-max h-max select-none"  draggable="false"/>}
        </button>
    );
};

export default Button;